module.exports = __webpack_public_path__ + "static/dr-javier-martinez-logos-43f348cef2c6551f77d05f7bac2ae6f8.svg";